import { getLocalStorage } from '../../utils/helpers';
import types from '../actionTypes';

const initialState = {
	token: getLocalStorage('token', null),
	id: null,
	email: null,
	name: null,
	surname: null,
	avatar: null,
	demo: false,
};

function userReducer(state = initialState, action) {
	switch (action.type) {
		case types.LOGIN:
			return {
				...state,
				token: action.payload,
			};
		case types.LOGOUT:
			return initialState;
		case types.GET_USER_DATA:
			return {
				...state,
				id: action.user.id,
				email: action.user.email,
				name: action.user.name,
				surname: action.user.surname,
				avatar: action.user.avatar,
				demo: false,
			};
		case types.LOGIN_DEMO:
			return {
				...state,
				id: action.id,
				levels_subjects_topics: action.levels_subjects_topics,
				demo: action.state,
			};
		default:
			return state;
	}
}

export default userReducer;
